var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBronzeTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.3869 1.7905C19.9669 1.34419 19.371 1.08689 18.7566 1.08689H16.8008C16.8087 0.73509 16.8139 0.372826 16.8139 0H4.19923C4.19923 0.372775 4.20446 0.73509 4.21236 1.08689H2.24337C1.62903 1.08689 1.03311 1.34419 0.613055 1.7905C0.187722 2.23947 -0.0327638 2.85375 0.00394969 3.47599C0.355753 9.34096 3.38277 13.0216 8.18182 13.5677L7.25245 16.8021C6.1472 16.8021 5.25198 17.6973 5.25198 18.8026V21.0026H15.7638V18.8026C15.7638 17.6973 14.8685 16.8021 13.7633 16.8021L12.8339 13.5677C17.6225 13.0164 20.6469 9.33835 20.9961 3.47599C21.0328 2.85642 20.8123 2.24208 20.3869 1.7905ZM2.10159 3.34995C2.09898 3.29221 2.12261 3.25283 2.14359 3.23181C2.18297 3.18982 2.23024 3.18982 2.24337 3.18982H4.31214C4.62456 7.31946 5.53553 9.66123 6.42029 10.9844C3.05199 9.57196 2.2486 5.79939 2.10159 3.34995ZM14.5929 10.9765C15.4776 9.65072 16.386 7.31157 16.6984 3.1872H18.7592C18.775 3.1872 18.8197 3.1872 18.859 3.2292C18.8801 3.25022 18.9036 3.2896 18.901 3.34733C18.7514 5.79678 17.9507 9.55883 14.5929 10.9765Z",
    fill: "#A6644F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeTrophy);
export default __webpack_public_path__ + "static/media/bronze_trophy.760df549e67ff2fe8bc07cbec7e38721.svg";
export { ForwardRef as ReactComponent };